//TODO[GP - future fix]: find better way to get country ids
export enum CountryIdentifiers {
  BANGLADESH_ID = '7',
  UAE_ID = '100',
  KUWAIT_ID = '47',
}
